import {
    GET_FILE_TYPES_FAIL,
    GET_FILE_TYPES_SUCCESS,
    ADD_FILE_TYPE_SUCCESS,
    ADD_FILE_TYPE_FAIL,
    UPDATE_FILE_TYPE_SUCCESS,
    UPDATE_FILE_TYPE_FAIL,
    DELETE_FILE_TYPE_SUCCESS,
    DELETE_FILE_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    fileTypes: [],
    error: null,
    loading: true
};

const fileTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des fileTypes
        case GET_FILE_TYPES_SUCCESS:
            return {
                ...state,
                fileTypes: action.payload, // tableau d'objets fileType
                loading: false,
                error: null
            };

        case GET_FILE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une fileTypee
        case ADD_FILE_TYPE_SUCCESS:
            return {
                ...state,
                fileTypes: [action.payload, ...state.fileTypes], // ajoute au début du tableau
                error: null
            };

        case ADD_FILE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une fileTypee
        case UPDATE_FILE_TYPE_SUCCESS:
            return {
                ...state,
                fileTypes: state.fileTypes.map(fileType =>
                    fileType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet fileType
                        : fileType
                ),
                error: null
            };

        case UPDATE_FILE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une fileTypee
        case DELETE_FILE_TYPE_SUCCESS:
            return {
                ...state,
                fileTypes: state.fileTypes.filter(
                    fileType => fileType.id !== action.payload
                ),
                error: null
            };


        case DELETE_FILE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default fileTypeReducer;
